import React, { useState } from 'react';

import { OfferOption, SelectedOffer } from '../../utils/backend-api/subscribe';
import SubscriptionForm from '../SubscriptionForm';
import ChoosePlanHeader from './ChoosePlanHeader';
import CorporateInquiry from './CorporateInquiry';
import MultipleOffers from './MultipleOffers';
import SingleOffer from './SingleOffer';

interface SubscribeProps {
  defaultSelectedOffer: SelectedOffer;
  description?: string;
  dob: string;
  isUserCBPT?: boolean;
  offers: OfferOption[];
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
  userNextBillingDate?: string;
}

const Subscribe = ({
  defaultSelectedOffer,
  description,
  dob,
  isUserCBPT,
  offers,
  stripeCustomerId,
  userFullName,
  userEmail,
  userNextBillingDate,
}: SubscribeProps) => {
  const [selectedOffer, setSelectedOffer] = useState(defaultSelectedOffer);
  const isSingleOffer = offers.length === 1;

  return (
    <div className="tw-mx-auto tw-mt-40 tw-w-full tw-px-12 md:tw-w-10/12 lg:tw-w-9/12">
      {!isSingleOffer && <ChoosePlanHeader description={description} />}
      <div className="tw-grid tw-grid-cols-1 tw-gap-16 sm:tw-grid-cols-2 sm:tw-gap-32">
        {isSingleOffer ? (
          <SingleOffer description={description} offer={offers[0]} selectedOffer={selectedOffer} />
        ) : (
          <MultipleOffers
            offers={offers}
            selectedOffer={selectedOffer}
            setSelectedOffer={setSelectedOffer}
          />
        )}
        <SubscriptionForm
          buttonText="Subscribe"
          dob={dob}
          formLocation="subscribe"
          isUserCBPT={isUserCBPT}
          selectedOffer={selectedOffer}
          stripeCustomerId={stripeCustomerId}
          userEmail={userEmail}
          userFullName={userFullName}
          userNextBillingDate={userNextBillingDate}
        />
      </div>
      <CorporateInquiry />
    </div>
  );
};

export default Subscribe;
